<template>
  <div class="count_down">
    <div class="count_item">
      <p>{{days[0]}}</p>
      <p>{{days[1]}}</p>
    </div>
    <p class="unit">天</p>
    <div class="count_item">
      <p>{{hours[0]}}</p>
      <p>{{hours[1]}}</p>
    </div>
    <p class="unit">时</p>
    <div class="count_item">
      <p>{{minutes[0]}}</p>
      <p>{{minutes[1]}}</p>
    </div>
    <p class="unit">分</p>
    <div class="count_item">
      <p>{{seconds[0]}}</p>
      <p>{{seconds[1]}}</p>
    </div>
    <p class="unit">秒</p>
  </div>
</template>

<script>
export default {
  props: ['startTime'],
  data() {
    return {
      timer: null,
      days: [],
      hours: [],
      minutes: [],
      seconds: []
    }
  },
  methods: {
    /**
     * 每隔一秒钟获取一下当前时间
     */
    getCurrentTime() {
      const startT = new Date(this.startTime && this.startTime.replace(/\-/gi, "/")).valueOf()

      this.timer = setInterval(() => {
        const currentTime = new Date().valueOf();
        const time = this.Util.timeStampTurn(startT, currentTime);
        if(currentTime >= startT) {
          this.$emit('onEmit')
        }
        this.days = time.days;
        this.hours = time.hours;
        this.minutes = time.minutes;
        this.seconds = time.seconds;
      }, 1000)
    }
  },
  mounted() {
    this.getCurrentTime()
  },
  destroyed() {
    if(this.timer) {
      clearInterval(this.timer)
    }
  }
}
</script>

<style scoped>
.count_down {
  display: flex;
  align-items: center;
}
.count_item {
  display: flex;
  align-items: center;
}
.count_item>p {
  background-color: rgb(0, 0, 0, 0.5);
  font-size: .36rem;
  color: #fff;
  margin-right: 1px;
}
.unit {
  font-size: .36rem;
  color: #fff;
}
</style>